import { render } from "./Parameter_edit.vue?vue&type=template&id=584db371&scoped=true"
import script from "./Parameter_edit.vue?vue&type=script&lang=js"
export * from "./Parameter_edit.vue?vue&type=script&lang=js"

import "./Parameter_edit.vue?vue&type=style&index=0&id=584db371&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584db371"]])

export default __exports__